import React,{useContext, useEffect, useReducer,  useState} from 'react';
import {Link} from 'react-router-dom';
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import {Dropdown, Nav, Tab} from 'react-bootstrap';


import { ThemeContext } from "../../../../context/ThemeContext";

import pdfMy from "../../../../icons/pdf/baw.pdf";



const SingleEntry = () => {
	const { changeBackground } = useContext(ThemeContext);	
	useEffect(() => {
		changeBackground({ value: "light", label: "Light" });
	}, []);
	
	return(
		<>
		<div className="row d-flex justify-content-between">
        {/* <BalanceCardSlider /> */}
    <div className="col-xl-12">
        <div className="card h-auto">
		<div className="card-body px-0 pt-1" style={{maxHeight:'100vh',overflowY:'auto'}}>
                <Tab.Container defaultActiveKey="Navbuy">
                    <div className="">
                        <Tab.Content>
                            <Tab.Pane eventKey="Navbuy">
                                <Tab.Container defaultActiveKey="Navbuymarket">
                                  
                                    <Tab.Content id="nav-tabContent1">
                                        <Tab.Pane eventKey="Navbuymarket"></Tab.Pane>
                                        <Tab.Pane eventKey="Navbuylimit"></Tab.Pane>
                                    </Tab.Content>
                                    <div className="sell-element">
                                    <div className=" col-lg-12">
         
            {/* <div className="card-header">
              <h4 className="card-title" style={{color:'rgba(23, 90, 169, 0.78)'}}>Single Invoice</h4><div className="mb-3 row">
                    <div className="col-sm-10">
                      <button type="submit" className="btn btn-primary">
                   Generate
                      </button>
                    </div>
                  </div>
            </div> */}
            <div className="card-body">
              {/* <div className="basic-form">
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Email</label>
                    <div className="col-sm-9">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Password</label>
                    <div className="col-sm-9">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Password"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Email</label>
                    <div className="col-sm-9">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Email</label>
                    <div className="col-sm-9">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Email</label>
                    <div className="col-sm-9">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Password</label>
                    <div className="col-sm-9">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Password"
                      />
                    </div>
                  </div> <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Email</label>
                    <div className="col-sm-9">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Password</label>
                    <div className="col-sm-9">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Password"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Email</label>
                    <div className="col-sm-9">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Password</label>
                    <div className="col-sm-9">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Password"
                      />
                    </div>
                  </div>
                 
                  
                </form>
              </div> */}
<h3>Coming Shortly...</h3>
            </div>
          </div>
        </div>
                                 
                                </Tab.Container>	
                            </Tab.Pane>							
                        </Tab.Content>
                    </div>
                </Tab.Container>	
            </div>
        </div>
    </div>
  
</div>
		</>
	)
}
export default SingleEntry;